import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { Box, useToken } from '@bonusly/design-system';

/**
 * Layout component specifically designed for iframe embedding
 * Responsive design that adapts to iframe container width (100% width, max 860px)
 * Allows vertical scrolling for unlimited feed content
 */
export const WidgetLayout: FC = () => {
	const widgetMaxWidth = useToken('breakpoints', 'sm');

	return (
		<Box
			width="100%"
			maxWidth={widgetMaxWidth}
			minHeight="600px"
			overflow="hidden"
			bg="bg.surface"
			position="relative"
			// Ensure the widget is self-contained for iframe embedding
			isolation="isolate"
			// Center the widget when it's narrower than its max width
			mx="auto"
		>
			<Outlet />
		</Box>
	);
};
